var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.block.attrs.text)?_c('p',{class:{
			['a-' + _vm.color]: true,
			[_vm.block.attrs.className
				? _vm.block.attrs.className
				: 'font-size-18']: true,
			[_vm.block.attrs.className == 'is-style-ask'
				? 'font-size-18 color-aili-black background-' +
				  _vm.pageColor +
				  '-light'
				: '']: true,
			[_vm.block.attrs.className == 'is-style-answer'
				? 'color-aili-black right'
				: '']: true
		},domProps:{"innerHTML":_vm._s(_vm.block.attrs.text)}}):_vm._e(),(_vm.block.attrs.className == 'is-style-answer')?_c('br',{staticClass:"clear"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }